// @ts-nocheck
import * as Types from '../../@types/apiql.generated.d';

import { gql } from '@apollo/client';
import { SubscribeOfferFieldsFragmentDoc, PassOfferFieldsFragmentDoc, RentOfferFieldsFragmentDoc, BuyOfferFieldsFragmentDoc } from './offerFields.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TGetAvailableOfferQueryVariables = Types.Exact<{
  offerId: Types.Scalars['String'];
}>;


export type TGetAvailableOfferQuery = { __typename?: 'Query', viewer: { __typename?: 'Viewer', id: string, offer?: { __typename: 'SubscribeType', id: string, title?: string | null, usps?: Array<string> | null, image?: string | null, priceInCents: any, currency: string, recurringPeriod?: { __typename?: 'RecurringPeriodType', length: number, unit: Types.TRecurringPeriodUnitType } | null, trialPeriod?: { __typename?: 'TrialPeriodType', length: any, unit: Types.TTrialPeriodUnitType } | null } | { __typename: 'BuyType', id: string, title?: string | null, usps?: Array<string> | null, image?: string | null, priceInCents: any, currency: string } | { __typename: 'DefaultType', id: string, title?: string | null, usps?: Array<string> | null, image?: string | null } | { __typename: 'PassType', id: string, title?: string | null, usps?: Array<string> | null, image?: string | null, priceInCents: any, currency: string, entitlementDurationSec?: number | null } | { __typename: 'RentType', id: string, title?: string | null, usps?: Array<string> | null, image?: string | null, priceInCents: any, currency: string, entitlementDurationSec?: number | null } | { __typename: 'ThirdPartyType', id: string, title?: string | null, usps?: Array<string> | null, image?: string | null } | null, entitlements: { __typename?: 'UserEntitlementsConnection', edges?: Array<{ __typename?: 'UserEntitlementsEdge', node: { __typename?: 'EntitlementSubscribeType', offerId?: string | null, id?: string | null } | { __typename?: 'EntitlementBuyType', offerId?: string | null, id?: string | null } | { __typename?: 'EntitlementDefaultType', offerId?: string | null, id?: string | null } | { __typename?: 'EntitlementPassType', offerId?: string | null, id?: string | null } | { __typename?: 'EntitlementPurchaseType', offerId?: string | null, id?: string | null } | { __typename?: 'EntitlementRentType', offerId?: string | null, id?: string | null } | { __typename?: 'EntitlementThirdPartyType', offerId?: string | null, id?: string | null } } | null> | null } } };


export const GetAvailableOfferDocument = gql`
    query getAvailableOffer($offerId: String!) {
  viewer {
    id: magineId
    offer(offerId: $offerId) {
      __typename
      id
      title
      usps
      image
      ...subscribeOfferFields
      ...passOfferFields
      ...rentOfferFields
      ...buyOfferFields
    }
    entitlements {
      edges {
        node {
          offerId
          id: offerId
        }
      }
    }
  }
}
    ${SubscribeOfferFieldsFragmentDoc}
${PassOfferFieldsFragmentDoc}
${RentOfferFieldsFragmentDoc}
${BuyOfferFieldsFragmentDoc}`;

/**
 * __useGetAvailableOfferQuery__
 *
 * To run a query within a React component, call `useGetAvailableOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableOfferQuery({
 *   variables: {
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useGetAvailableOfferQuery(baseOptions: Apollo.QueryHookOptions<TGetAvailableOfferQuery, TGetAvailableOfferQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TGetAvailableOfferQuery, TGetAvailableOfferQueryVariables>(GetAvailableOfferDocument, options);
      }
export function useGetAvailableOfferLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGetAvailableOfferQuery, TGetAvailableOfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TGetAvailableOfferQuery, TGetAvailableOfferQueryVariables>(GetAvailableOfferDocument, options);
        }
export type GetAvailableOfferQueryHookResult = ReturnType<typeof useGetAvailableOfferQuery>;
export type GetAvailableOfferLazyQueryHookResult = ReturnType<typeof useGetAvailableOfferLazyQuery>;
export type GetAvailableOfferQueryResult = Apollo.QueryResult<TGetAvailableOfferQuery, TGetAvailableOfferQueryVariables>;